import React from 'react';
import { CheckCircle } from 'lucide-react';

const Pricing = ({ prices, onOrderClick }) => {
  return (
    <div id="preturi">
      <div className="max-w-6xl mx-auto py-16 px-4">
      <h2 className="text-3xl font-bold text-center mb-12">Taxa ONRC inclusă, fără costuri ascunse</h2>

      <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {/* Certificat Constatator */}
        <div className="bg-white rounded-xl shadow-lg p-8 border-2 border-gray-200 hover:border-teal-500 transition-all">
          <h3 className="text-2xl font-bold mb-2">Certificat constatator</h3>
          <p className="text-sm text-gray-600 mb-4">Taxa ONRC inclusă</p>
          <p className="text-5xl font-bold text-gray-900 mb-6">
            {prices.basic} lei<span className="text-lg text-gray-500"> TVA inclus</span>
          </p>

          <ul className="space-y-3 mb-6">
            <li className="flex items-start">
              <CheckCircle className="w-5 h-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" />
              <span className="text-sm">Document cu semnătură electronică</span>
            </li>
            <li className="flex items-start">
              <CheckCircle className="w-5 h-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" />
              <span className="text-sm">Document eliberat original</span>
            </li>
            <li className="flex items-start">
              <CheckCircle className="w-5 h-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" />
              <span className="text-sm">Notificare GRATUITĂ prin SMS și email despre stadiul comenzii</span>
            </li>
            <li className="flex items-start">
              <CheckCircle className="w-5 h-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" />
              <span className="text-sm">Factură electronică</span>
            </li>
            <li className="flex items-start">
              <CheckCircle className="w-5 h-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" />
              <span className="text-sm">Suport telefonic L-V 09:00-17:00</span>
            </li>
          </ul>
        </div>

        {/* Certificat cu Istoric */}
        <div className="bg-white rounded-xl shadow-lg p-8 border-2 border-gray-200 hover:border-teal-500 transition-all">
          <h3 className="text-2xl font-bold mb-2">Certificat cu istoric</h3>
          <p className="text-sm text-gray-600 mb-4">Taxa ONRC inclusă</p>
          <p className="text-5xl font-bold text-gray-900 mb-6">
            {prices.withHistory} lei<span className="text-lg text-gray-500"> TVA inclus</span>
          </p>

          <ul className="space-y-3 mb-6">
            <li className="flex items-start">
              <CheckCircle className="w-5 h-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" />
              <span className="text-sm">Document cu semnătură electronică</span>
            </li>
            <li className="flex items-start">
              <CheckCircle className="w-5 h-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" />
              <span className="text-sm">Document eliberat original</span>
            </li>
            <li className="flex items-start">
              <CheckCircle className="w-5 h-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" />
              <span className="text-sm">Notificare GRATUITĂ prin SMS și email despre stadiul comenzii</span>
            </li>
            <li className="flex items-start">
              <CheckCircle className="w-5 h-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" />
              <span className="text-sm">Factură electronică</span>
            </li>
            <li className="flex items-start">
              <CheckCircle className="w-5 h-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" />
              <span className="text-sm">Suport telefonic L-V 09:00-17:00</span>
            </li>
          </ul>
        </div>

        {/* Majorare Capital Social */}
        <div className="bg-white rounded-xl shadow-lg p-8 border-2 border-gray-200 hover:border-teal-500 transition-all">
          <h3 className="text-2xl font-bold mb-2">Majorare Capital Social</h3>
          <p className="text-sm text-gray-600 mb-4">Preț de la</p>
          <p className="text-5xl font-bold text-gray-900 mb-6">
            720 lei<span className="text-lg text-gray-500"> TVA inclus</span>
          </p>

          <ul className="space-y-3 mb-6">
            <li className="flex items-start">
              <CheckCircle className="w-5 h-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" />
              <span className="text-sm">Consultanță inițială, înainte de depunerea dosarului</span>
            </li>
            <li className="flex items-start">
              <CheckCircle className="w-5 h-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" />
              <span className="text-sm">Redactarea tuturor documentelor necesare</span>
            </li>
            <li className="flex items-start">
              <CheckCircle className="w-5 h-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" />
              <span className="text-sm">Asistență și garanție până la obținerea documentelor finale</span>
            </li>
          </ul>

          <a
            href="https://inregistrarefirma.com/servicii/majorare-capital-social?utm_source=constatatoare.ro&utm_medium=pricing_card&utm_campaign=majorare_capital"
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full bg-teal-600 text-white text-center py-3 rounded-lg font-semibold hover:bg-teal-700 transition-colors"
          >
            Vezi detalii
          </a>
        </div>
      </div>
    </div>

      {/* Verificare Autenticitate ONRC - Full Width */}
      <div className="bg-gradient-to-r from-blue-600 to-blue-700 py-16 text-center text-white">
        <div className="max-w-4xl mx-auto px-4">
          <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
          </div>

          <h3 className="text-2xl md:text-3xl font-bold mb-4">Document oficial emis de ONRC</h3>

          <p className="text-blue-100 max-w-2xl mx-auto mb-8">
            Certificatul constatator livrat prin intermediul serviciului nostru este emis oficial
            de către ONRC (Oficiul Național al Registrului Comerțului) și poate fi acceptat de
            toate instituțiile statului, bănci, notari și instanțe judecătorești.
          </p>

          <div className="bg-white/10 backdrop-blur rounded-xl p-6 max-w-lg mx-auto">
            <h4 className="font-semibold text-lg mb-2">Verifică autenticitatea documentului</h4>
            <p className="text-blue-100 text-sm mb-4">
              Toate certificatele constatator emise prin platforma noastră pot fi verificate
              pe site-ul oficial ONRC folosind codul de bare de pe prima pagină a documentului.
            </p>
            <a
              href="https://myportal.onrc.ro/authenticity-verification"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-white text-blue-600 font-semibold px-6 py-3 rounded-lg hover:bg-blue-50 transition-colors"
            >
              VERIFICĂ PE ONRC.RO
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pricing;
